import {UserPlus} from 'lucide-react';
import {createLucideIcon} from '../create-lucide-icon';

export const GroupAddIcon = createLucideIcon(UserPlus, 'GroupAddIcon');
